import * as React from "react";
import moment from "moment";
import reduce from "lodash/reduce";
import {
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip
} from "recharts";
import { parseApiDate } from "../../helpers/date";
import Select from "../../components/select";
import { IWorkout } from "../../resources/user/types";
import { exercisesConfig } from "../../constants/exercises";
import styles from "./measurements.module.css";

interface IProps {
  workouts: IWorkout[];
}

const getHighestByWeight = (exerciseSets: any) =>
  reduce(exerciseSets, (a, v) => (v.weight > a.weight ? v : a), { weight: 0 });

const exercises = exercisesConfig.sort((a, b) => a.pos - b.pos);

export default function WorkoutProgress({ workouts }: IProps) {
  const ref = React.useRef<any>(null);
  const [exercise, setExercise] = React.useState<string>("squat");
  const [data, setData] = React.useState<{ x: string; y: number }[]>([]);

  const onExerciseChange = (e: any) => setExercise(e.target.value);

  React.useEffect(() => {
    const d = workouts
      .filter(
        workout =>
          workout.exercises?.find(ex => ex.id === exercise) &&
          parseApiDate(workout.date).isBefore(moment())
      )
      .sort((a, b) => a.timestamp - b.timestamp)
      .map(workout => ({
        x: parseApiDate(workout.date).format("M/D/YY"),
        y: getHighestByWeight(
          workout.exercises?.find(ex => ex.id === exercise)?.exerciseSets
        ).weight
      }));
    setData(d);
  }, [exercise, workouts]);

  return workouts.length > 0 ? (
    <div ref={ref}>
      <Select
        className={styles.select}
        value={exercise}
        onChange={onExerciseChange}
      >
        {exercises.map(opt => (
          <option key={opt.id} value={opt.id}>
            {opt.title}
          </option>
        ))}
      </Select>
      {ref ? (
        <AreaChart
          width={document.body.clientWidth - 20}
          height={200}
          data={data}
          margin={{ top: 5, right: 5, bottom: 5, left: 0 }}
        >
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#db4453" stopOpacity={0.8} />
              <stop offset="100%" stopColor="#db4453" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid vertical={false} stroke="#ccc" />
          <XAxis dataKey="x" minTickGap={20} interval="preserveStartEnd" />
          <YAxis tickCount={3} />
          <Tooltip
            formatter={(value: any) => {
              return [`${value} Pounds`, ""];
            }}
            separator=""
          />
          <Area
            type="monotone"
            dataKey="y"
            stroke="#db4453"
            fillOpacity={1}
            fill="url(#colorUv)"
          />
        </AreaChart>
      ) : null}
    </div>
  ) : null;
}
